import type { MediaReadyPatch } from "@/features/inbox/types";
import { ATTACHMENT_STATUS, Attachment, Message } from "@/types/message";

export const applyMediaReadyToAttachment = (
  attachment: Attachment,
  patch: MediaReadyPatch,
): Attachment => {
  if (attachment.id !== patch.attachmentId) return attachment;

  return {
    ...attachment,
    url: patch.url,
    contentType: patch.contentType ?? attachment.contentType,
    type: patch.type ?? attachment.type,
    status: ATTACHMENT_STATUS.READY,
  };
};

export const applyMediaReadyToMessage = (
  message: Message,
  patch: MediaReadyPatch,
): Message => {
  const hasTarget = message.attachments.some(
    (attachment) => attachment.id === patch.attachmentId,
  );

  if (!hasTarget) return message;

  return {
    ...message,
    attachments: message.attachments.map((attachment) =>
      applyMediaReadyToAttachment(attachment, patch),
    ),
  };
};
